import type { Story } from '@/types/cmsTypes';
import type { ProjectInstance } from '@/types/projectTypes';

export interface ProjectLocationView {
  latitude: number;
  longitude: number;
  address?: string;
  city?: string;
  starting_point?: string | null;
}

type LocationInfo = NonNullable<Story['locationInfo']> | ProjectInstance['locationInfo'];

const hasLocation = (story: Story) =>
  Boolean(story.locationInfo?.address || (story.locationInfo?.coordinates?.lat && story.locationInfo?.coordinates?.lng));

function view(info: LocationInfo | null | undefined): ProjectLocationView {
  if (!info) return { latitude: 0, longitude: 0 };
  return {
    latitude: info.coordinates?.lat ?? 0,
    longitude: info.coordinates?.lng ?? 0,
    address: info.address,
    city: info.city,
    starting_point: (info as { starting_point?: string | null }).starting_point,
  };
}

export function projectLocation(project: ProjectInstance, stories: Story[]): ProjectLocationView {
  const story = stories.find(hasLocation);
  return view(story?.locationInfo ?? project.locationInfo);
}
